// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 1L21 23H3V1H21ZM17 13H7V15H17V13ZM15 17H7V19H15V17ZM11 3H7L7 8.5L9 6.85L11 8.5V3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-certificate-1-filled')
export default class Certificate1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'certificate-1-filled',
    }
  }
}
